// @ts-nocheck
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Alert } from 'loyal-react'
import twoFactorAuthentication from '../Checkout/actions'
import InputRange from './InputRange'
import { StixWrapper, StixHeader, StixInfos, SideBar, StixStars } from './'
import PropTypes from 'prop-types'
import scrollToComponent from 'react-scroll-to-component'
import MediaQuery from 'react-responsive'
import { actions as mileageActions } from '../Services/Mileage'
import { filterPartnerMileage } from '../Services/Mileage/actions'
import * as actions from './actions'
import { SecondFactorAuthentication } from '../Checkout/SecondFactorAuthenticaton'

class Stix extends Component {
  constructor (props) {
    super(props)

    this.state = {
      step: this.props.stix.supplierId ? 2 : 1,
      loadingPayment: false,
      totalPoints: 0,
      totalStars: 0,
      error: false,
      partnerName: '',
      paymentSelected: 'POINTS_ONLY',
      equivalence: 0,
      multipliceRule: 0,
      configurationRule: false,
      Partners: this.props.partners
    }

    this.HandlerValueSelected = this.HandlerValueSelected.bind(this)
    this.updateRulesToState = this.updateRulesToState.bind(this)
  }

  showError () {
    return this.props.errorRedemption && this.props.errorRedemption !== '' ? (
      <Alert
        isError
        title={'Não foi possível concluir a sua transferência.'}
        description='Erro ao tentar efetuar o resgate'
        className='pb-2'
        onClose={() => this.props.closeErrorMileage()}
      />
    ) : (
      ''
    )
  }

  MessageBalanceLimit () {
    return this.ValidationBalanceLimit() ? (
      <Alert
        isError
        title={'Não podemos prosseguir com a operação!'}
        description='Seu saldo é insulficiente para a transferência.'
        className='pb-2'
      />
    ) : (
      ''
    )
  }

  ValidationBalanceLimit () {
    return parseInt(this.state.totalPoints) > parseInt(this.props.pointsValue)
  }

  selectPartner (e) {
    if (e && e.target) {
      const partnerName = this.props.partners.find(x => x.vendorId === parseInt(e.target.value)).name

      this.props.toggleSupplierId(e.target.value)

      this.setState({
        partnerName,
        totalPoints: 0,
        totalStars: 0
      })
    }
  }

  nextStep (step) {
    this.setState({ step: step })
  }

  HandlerValueSelected (CallbackComponent) {
    const { totalPoints, totalCurrency } = CallbackComponent

    this.setState({
      totalPoints,
      totalStars: totalCurrency
    })
  }

  getOrderRequest = () => ({
    totalMiles: this.state.totalPoints,
    totalPoints: this.state.totalPoints,
    catalogId: this.props.catalog.id,
    transferKey: 'cpf',
    loyaltyNumber: this.props.participant.cpf.value,
    cpf: this.props.participant.cpf.value,
    participantName: this.props.participant.name.value,
    offline: false,
    orderItems: [
      {
        quantity: 1,
        points: this.state.totalPoints,
        miles: this.state.totalPoints,
        totalPoints: this.state.totalPoints,
        packageName: `${this.state.totalStars} estrela${this.state.totalStars > 1 && 's'}`
      }
    ],
    orderTypeId: 1
  })

  handlerFinalizePayment = () => {
    this.props.mileageRedemption(
      this.getOrderRequest(),
      this.props.stix.supplierId
    )
  }

  disableConfigurationRule (value) {
    this.setState({
      configurationRule: value
    })
  }

  PartnerName (value) {
    this.setState({
      partnerName: value
    })
  }

  getConfigurationByKey = key =>
    this.props.configuration[this.props.stix.supplierId].filter(
      x => x.key === key
    )

  updateMaximumRedemptionLimit () {
    if (
      this.props.stix.minimumRedemptionLimit === 0 ||
      this.props.pointsValue === 0
    ) {
      return
    }

    this.props.changeMaximumRedemptionLimit(
      ~~(this.props.pointsValue / this.props.stix.minimumRedemptionLimit) *
        this.props.stix.minimumRedemptionLimit
    )
  }

  updateRulesToState (equivalence, multiplicityRule) {
    console.log(equivalence, multiplicityRule)
    this.setState({
      equivalence: parseInt(equivalence[0].value),
      multipliceRule: parseInt(multiplicityRule[0].value)
    })
  }

  // #region [Life clycle]

  componentDidUpdate (prevProps) {
    if (prevProps.enableConfiguration !== this.props.enableConfiguration) {
      const partnerName = this.props.partners.length > 0 && this.props.partners.find(x => x.vendorId === parseInt(this.props.supplierId)).name

      this.PartnerName(partnerName)

      this.disableConfigurationRule(this.props.enableConfiguration)
    }

    if (prevProps.configuration !== this.props.configuration) {
      const minimumRedemptionLimit = this.getConfigurationByKey(
        'MinimumRedemptionLimit'
      )
      const equivalencePoints = this.getConfigurationByKey('EquivalencePoints')
      const multiplicityRule = this.getConfigurationByKey('MultiplicityRule')

      if (equivalencePoints === undefined) { return }

      if (multiplicityRule === undefined) { return }

      if (minimumRedemptionLimit === undefined) { return }

      this.updateRulesToState(equivalencePoints, multiplicityRule)

      const minimumLimit = parseInt(minimumRedemptionLimit[0].value)

      this.props.changeMinimumRedemptionLimit(minimumLimit)

      if (this.props.stix.redemptionPoints < minimumLimit) {
        this.props.changeRedemptionPoints(minimumRedemptionLimit)
      }
    }

    if (
      prevProps.pointsValue !== this.props.pointsValue ||
      prevProps.stix.minimumRedemptionLimit !==
        this.props.stix.minimumRedemptionLimit
    ) {
      this.updateMaximumRedemptionLimit()
    }
  }

  // #endregion

  disabledVerify () {
    return this.state.totalStars === 0 || this.ValidationBalanceLimit()
  }

  render () {
    const isMobile = this.props.isMobile

    return (
      <StixWrapper>
        {this.showError()}
        {this.MessageBalanceLimit()}
        <div className='col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '>
          <div className='row mx-0'>
            <div className='modalConfirmationVoucher'>
              <SecondFactorAuthentication
                show={this.props.sendTwoFactorAuthorization.enable}
                secondFactorAuthConfirmated={
                  this.props.sendTwoFactorAuthorization
                    .secondFactorAuthConfirmated
                }
                sendTwoFactorAuthorization={this.props.sendTwoFactorAuthorization}
                authorizeWithTokenMileage={this.props.authorizeWithTokenMileage}
                authorizeWithTokenResend={this.props.authorizeWithTokenResend}
                authorizeWithTokenLastTry={this.props.authorizeWithTokenLastTry}
                vendorId={Number(this.props.stix.supplierId)}
                errorToken={this.props.sendTwoFactorAuthorization.errorToken}
                paymentSelected={this.state.paymentSelected}
              />
            </div>
            <div className='col-12 radius border border-color-ui-3'>
              <StixHeader>Transfira pontos para parceiros</StixHeader>
              <div className='stix-content row radius-bottom bg-white px-1 py-3'>
                <div className='Step1 step-1 col-12'>
                  <div className='row mx-0'>
                    <div className='col-12'>
                      <p className='txt-body pb-1'>
                        Escolha um dos programas parceiros para transferir seus
                        pontos.
                      </p>
                    </div>
                    <div className='col-12'>
                      <ul className='stix-partners row'>
                        {this.props.partners && this.props.partners.length > 0
                          ? this.props.partners.map((Partner, index) => (
                            <li
                              key={index}
                              className={`stix-partner col-6 col-md-auto py-half`}
                            >
                              <label
                                onClick={() =>
                                  setTimeout(() => {
                                    this.nextStep(2)
                                    scrollToComponent(this.Step2, {
                                      offset: -120,
                                      align: 'top',
                                      duration: 500,
                                      ease: 'inCirc'
                                    })
                                  }, 300)
                                }
                                className={`txt-center px-1 px-md-4 ${(parseInt(this
                                  .props.stix.supplierId) === Partner.vendorId &&
                                    'active') ||
                                    ''}`}
                                htmlFor={`partner_${Partner.vendorId}`}
                              >
                                <input
                                  name={`partnerId`}
                                  className='txt-center pb-1 pt-1'
                                  type='radio'
                                  id={`partner_${Partner.vendorId}`}
                                  value={Partner.vendorId}
                                  onChange={e => this.selectPartner(e)}
                                />
                                <img
                                  src={Partner.logoUrl}
                                  title={Partner.name}
                                  className='mw-100 mx-auto'
                                />
                              </label>
                            </li>
                          ))
                          : ''}
                      </ul>
                    </div>
                  </div>
                </div>
                {!this.props.enableConfiguration && (
                  <div id='step-2' className='btn-loading mr-auto ml-auto mt-3'>
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                )}
                {this.props.enableConfiguration && (
                  <div
                    id='step-2'
                    className={`Step2 step-2 col-12 px-2 pt-3`}
                    ref={section => {
                      this.Step2 = section
                    }}
                  >
                    <div className='row mx-0 border-color-ui-3 border-top pt-3 '>
                      <div className='col-12 px-0'>
                        <div className='row bg-ui-custom mx-0 radius py-0 py-md-3'>
                          <div className='col-12 px-0 px-md-2'>
                            <p className='txt-body pb-half'>
                                Quantos pontos deseja transferir?
                            </p>
                          </div>
                          <div className='col-12 px-0 px-md-2'>
                            <div className='row  align-items-center'>
                              <div className='box-quantity col-12 col-md'>
                                <InputRange
                                  minimunValue={
                                    this.props.stix.minimumRedemptionLimit
                                  }
                                  maximunValue={
                                    this.props.stix.maximumRedemptionLimit
                                  }
                                  multipliceRule={this.state.multipliceRule}
                                  step={
                                    this.props.stix.minimumRedemptionLimit
                                  }
                                  equivalence={this.props.stix.minimumRedemptionLimit}
                                  handlerValueSelected={
                                    this.HandlerValueSelected
                                  }
                                  isDivisible
                                />
                              </div>
                              <div className='col-12 col-md-auto txt-center my-2 my-md-0'>
                                <span className='icon-equal'>=</span>
                                <span className='equal-line d-md-none d-block' />
                              </div>
                              <div className='col-12 col-md  my-2 my-md-0'>
                                <div className='row'>
                                  <div className='col-12'>
                                    <p>
                                        Você vai receber no{' '}
                                      <strong>{this.state.partnerName}</strong>:
                                    </p>
                                  </div>
                                  <div className='col-12 pt-half'>
                                    <p className='txt-title-1'>
                                      <i className='icon icon-sm icon_rating color-featured d-inline-block' />{' '}
                                      <strong className='color-featured pl-1 txt-title-2'>
                                        <StixStars totalStars={this.state.totalStars} />
                                      </strong>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {(!isMobile || this.state.step >= 3) && (
                  <div
                    id='step-3'
                    className='Step3 step-3 col-12 bg-white pt-0 pt-md-3'
                    ref={section => {
                      this.Step3 = section
                    }}
                  >
                    <StixInfos equivalence={this.props.stix.minimumRedemptionLimit} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {(!isMobile || this.state.step >= 4) && (
          <div
            className='col-12 col-md-4'
            ref={section => {
              this.Step4 = section
            }}
          >
            <div className='row'>
              <SideBar
                loadingPayment={this.props.mileageIsLoading}
                disabledButton={this.disabledVerify()}
                partnerName={this.state.partnerName}
                creditValue={this.state.totalPoints}
                starValue={this.state.totalStars}
                handlerFinalizePayment={this.handlerFinalizePayment}
              />
            </div>
          </div>
        )}
        <MediaQuery maxDeviceWidth={480}>
          {(this.state.step === 2 || this.state.step === 3) && (
            <div className='step-next col-12 bg-white'>
              {this.state.step === 2 && (
                <button
                  className='btn btn-featured btn-sm'
                  onClick={() =>
                    setTimeout(() => {
                      this.nextStep(3)
                      scrollToComponent(this.Step3, {
                        offset: -120,
                        align: 'top',
                        duration: 500,
                        ease: 'inCirc'
                      })
                    }, 300)
                  }
                >
                  Próximo passo
                </button>
              )}
              {this.state.step === 3 && (
                <button
                  className='btn btn-featured btn-sm'
                  onClick={() =>
                    setTimeout(() => {
                      this.nextStep(4)
                      scrollToComponent(this.Step4, {
                        offset: -120,
                        align: 'top',
                        duration: 500,
                        ease: 'inCirc'
                      })
                    }, 300)
                  }
                >
                  Próximo passo
                </button>
              )}
            </div>
          )}
        </MediaQuery>
      </StixWrapper>
    )
  }
}

const mapStateToProps = ({ mileage, stix, balance, catalog, participant }) => ({
  mileageIsLoading: mileage.isLoading,
  errorRedemption: mileage.errorRedemption,
  configuration: mileage.configuration,
  stix: stix,
  balanceIsLoading: balance.isLoading,
  pointsValue: balance.pointsValue,
  catalog: catalog,
  participant: participant,
  sendTwoFactorAuthorization: mileage.sendTwoFactorAuthorization,
  enableConfiguration: mileage.enableConfiguration,
  partners: filterPartnerMileage(mileage.partners, false)
})

const mapDispatchToProps = dispatch => ({
  toggleSupplierId: supplierId =>
    dispatch(actions.toggleSupplierId(supplierId)),
  changeRedemptionPoints: pointsAmout =>
    dispatch(actions.changeRedemptionPoints(pointsAmout)),
  changeMinimumRedemptionLimit: minimumRedemptionLimit =>
    dispatch(actions.changeMinimumRedemptionLimit(minimumRedemptionLimit)),
  changeMaximumRedemptionLimit: maximumRedemptionLimit =>
    dispatch(actions.changeMaximumRedemptionLimit(maximumRedemptionLimit)),
  mileageRedemption: (order, supplierId) =>
    dispatch(mileageActions.mileageRedemption(order, supplierId)),
  closeErrorMileage: () => dispatch(mileageActions.closeErrorMileage()),
  authorizeWithTokenMileage: (orderId, Token, orderIdMileage, vendorId) =>
    dispatch(
      mileageActions.authorizeWithTokenMileage(
        orderId,
        Token,
        orderIdMileage,
        vendorId
      )
    ),
  authorizeWithTokenResend: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      twoFactorAuthentication.authorizeWithTokenResend(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    ),
  authorizeWithTokenLastTry: (
    OrderId,
    PaymentMoneyRequest,
    Token,
    TokenType,
    Resend
  ) =>
    dispatch(
      twoFactorAuthentication.authorizeWithTokenLastTry(
        OrderId,
        PaymentMoneyRequest,
        Token,
        TokenType,
        Resend
      )
    )
})

Stix.propTypes = {
  stix: PropTypes.object,
  mileageIsLoading: PropTypes.bool,
  pointsValue: PropTypes.number,
  supplierId: PropTypes.number,
  isMobile: PropTypes.bool,
  configuration: PropTypes.object,
  participant: PropTypes.object,
  catalog: PropTypes.object,
  partners: PropTypes.object,
  toggleSupplierId: PropTypes.func,
  changeRedemptionPoints: PropTypes.func,
  changeMinimumRedemptionLimit: PropTypes.func,
  changeMaximumRedemptionLimit: PropTypes.func,
  mileageRedemption: PropTypes.func,
  errorRedemption: PropTypes.string,
  sendTwoFactorAuthorization: PropTypes.object,
  authorizeWithTokenMileage: PropTypes.func,
  authorizeWithTokenResend: PropTypes.func,
  authorizeWithTokenLastTry: PropTypes.func,
  closeErrorMileage: PropTypes.func,
  enableConfiguration: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(Stix)



// WEBPACK FOOTER //
// ./src/features/Stix/Stix.js